import React from "react";
import useLocale from "./use-locale";

export default function useOnLocaleChange(callback) {

    const locale = useLocale();
    
    React.useEffect(() => {
        const disposer = locale.observe(() => {
            if(typeof callback === 'function') {
                callback(locale.get());
            }
        });

        return () => {
            disposer();
        }
    }, [locale, callback]);

}
